import { BLOCKS, INLINES } from '@contentful/rich-text-types'

import type { Document as RichTextDocument } from '@contentful/rich-text-types'

export interface FAQ {
  title: string
  description: RichTextDocument
}

export const faqs: FAQ[] = [
  {
    title: `Is there a free trial of the paid plans?`,
    description: {
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: `Yes! There is a 14-day free trial for Connections. Learn more `,
                  nodeType: `text`,
                },
                {
                  data: {
                    uri: `/pricing/connections/`,
                  },
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: `here`,
                      nodeType: `text`,
                    },
                  ],
                  nodeType: INLINES.HYPERLINK,
                },
                {
                  data: {},
                  marks: [],
                  value: `. For CDP plans, please `,
                  nodeType: `text`,
                },
                {
                  data: {
                    uri: `/demo/`,
                  },
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: `contact us`,
                      nodeType: `text`,
                    },
                    {
                      data: {},
                      marks: [],
                      value: `.`,
                      nodeType: `text`,
                    },
                  ],
                  nodeType: INLINES.HYPERLINK,
                },
              ],
              nodeType: BLOCKS.PARAGRAPH,
            },
          ],
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    },
  },
  {
    title: `Do I need to purchase a Connections and a CDP plan?`,
    description: {
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: `No! Connections capabilities are included in all Customer Data Platform (CDP) plans. For teams only focused on collecting and sending customer data to downstream destinations, Connections plans are a great place to start and can be upgraded to a CDP plan when your team is ready.`,
              nodeType: `text`,
            },
          ],
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    },
  },
  {
    title: `Are the artificial intelligence capabilities included in plans?`,
    description: {
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: `Predictive and Generative AI capabilities are available in select Customer Data Platform (CDP) plans. Recommended Audiences are available as an add-on to Engage plans. `,
              nodeType: `text`,
            },
            {
              data: {
                uri: `/pricing/customer-data-platform/`,
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: `Learn more`,
                  nodeType: `text`,
                },
              ],
              nodeType: INLINES.HYPERLINK,
            },
            {
              data: {},
              marks: [],
              value: ` about CDP plans.`,
              nodeType: `text`,
            },
          ],
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    },
  },
  {
    title: `How can I buy Protocols, Unify or Twilio Engage?`,
    description: {
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: `Protocols is included in all Customer Data Platform (CDP) plans and an optional add-on for Connections Business plans. Unify and Twilio Engage are available CDP plans. `,
              nodeType: `text`,
            },
            {
              data: {
                uri: `/pricing/customer-data-platform/`,
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: `Learn more`,
                  nodeType: `text`,
                },
              ],
              nodeType: INLINES.HYPERLINK,
            },
            {
              data: {},
              marks: [],
              value: ` about CDP plans, or `,
              nodeType: `text`,
            },
            {
              data: {
                uri: `/demo/`,
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: `contact us`,
                  nodeType: `text`,
                },
              ],
              nodeType: INLINES.HYPERLINK,
            },
            {
              data: {},
              marks: [],
              value: ` to determine which plan is best for you.`,
              nodeType: `text`,
            },
          ],
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    },
  },
]
